<template>
  <transition>
    <v-row class="loading ma-0" justify="center" align="center">
      <v-col class="pa-0 ma-0" align="center" justify="center">
        <v-progress-circular
          class="loader"
          indeterminate
          :color="color"
          size="64"
        />
      </v-col>
    </v-row>
  </transition>
</template>

<script>
export default {
  name: 'Loader',
  data() {
    return {
      color: '#01ee55',
    };
  },
  mounted() {
    this.checkClass();
  },
  methods: {
    checkClass() {
      if (document.querySelector('.new-color')) {
        this.color = '#26d07c';
      }
    },
  },
};
</script>

<style lang="sass" scoped>
.loading
  position: fixed
  top: 0px
  left: 0px
  background-color: rgb(0, 0, 0, 0.3)
  z-index: 9999
  width: 100%
  height: 100%

.new-color
  .loading
    background-color: rgb(0, 48, 54, 0.3)
</style>
